
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/wagtail",
      function () {
        return require("private-next-pages/wagtail.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/wagtail"])
      });
    }
  